(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rosy-purchase-planner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rosy-product-date]').forEach((root) => {
    const input = root.querySelector('[data-event-date-input]');
    const checkButton = root.querySelector('[data-check-date]');
    const clearButton = root.querySelector('[data-clear-date]');
    const result = root.querySelector('[data-date-result]');
    const storageKey = 'rosy_v5_event_date';

    const parseDate = (value) => {
      const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) return null;
      const month = Number(match[1]);
      const day = Number(match[2]);
      const year = Number(match[3]);
      const date = new Date(year, month - 1, day, 12);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
      return date;
    };

    const saveCartAttribute = async (value) => {
      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Event Date': value } })
        });
      } catch (error) {
        return;
      }
    };

    const assess = () => {
      const eventDate = parseDate(input.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      result.hidden = false;
      if (!eventDate) {
        result.textContent = 'Enter a valid date in MM/DD/YYYY format.';
        return;
      }
      if (eventDate < today) {
        result.textContent = 'Please choose a future event date.';
        return;
      }

      const days = Math.round((Date.UTC(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
      let message = 'Your event is at least 49 days away. Estimated production and delivery is 35–49 days; arrival by your event is not guaranteed.';
      if (days < 35) {
        message = 'Your event is less than 35 days away, earlier than the estimated 35–49 day window. Contact us before ordering to review any available expedited options.';
      } else if (days < 49) {
        message = 'Your event falls within the estimated 35–49 day window. Delivery may be too late; contact us before ordering.';
      }
      result.textContent = message;
      clearButton.hidden = false;
      localStorage.setItem(storageKey, input.value);
      saveCartAttribute(input.value);
    };

    const savedDate = localStorage.getItem(storageKey);
    if (savedDate) {
      input.value = savedDate;
      assess();
    }

    checkButton.addEventListener('click', assess);
    clearButton.addEventListener('click', () => {
      input.value = '';
      result.hidden = true;
      clearButton.hidden = true;
      localStorage.removeItem(storageKey);
      saveCartAttribute('');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
